var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"innerItem"},[_c('button',{staticClass:"btn btnFull btnPrimary",attrs:{"type":"button"},on:{"click":_vm.onSave}},[_vm._v(_vm._s(_vm.locale.save))])]),_c('div',{staticClass:"innerItem"},[_c('router-link',{staticClass:"btn btnFull",attrs:{"to":"/localinfo/create"}},[_vm._v(_vm._s(_vm.locale.localinfo_created))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }